import {
  Vehicle,
  Announcement,
  ObserveRefreshData,
} from "../../../../types/observe";

import VehicleSelect from "./vehicleSelect/VehicleSelect";
import CrArea from "./crArea/CrArea";
import VideoSwitch from "./videoSwitch/VideoSwitch";
import AudioSwitch from "./audioSwitch/AudioSwitch";
import SoundSelect from "./soundSelect/SoundSelect";
import RemoteAssist from "./remoteAssist/RemoteAssist";
import EiheijiRemoteControl from "./eiheijiRemoteControl/EiheijiRemoteControl";
import { isEiheijiEnvironment } from "../../../../utils/environment";

import "./VehiclePanel.scss";

interface VehiclePanelProps {
  layoutId: number;
  vehicle: Vehicle | null;
  announcement: Announcement[];
  selectableVehicles: Vehicle[];
  refreshData: ObserveRefreshData | null;
  monitorConsoleId: number | null;
  observeCC: string | null;
  onevehicleCC: string | null;
  sendData: (msg: object) => void;
  onModalOpen: (message: string) => void;
  onReconnectJanus: (
    vehicleId: number,
    action: "connect" | "disconnect"
  ) => void;
  isDepartureAnnounceActive?: boolean;
  isAnyRemoteMode?: boolean;
}

const VehiclePanel = ({
  layoutId,
  vehicle,
  announcement,
  selectableVehicles,
  refreshData,
  monitorConsoleId,
  observeCC,
  onevehicleCC,
  sendData,
  onModalOpen,
  onReconnectJanus,
  isDepartureAnnounceActive = false,
  isAnyRemoteMode = false,
}: VehiclePanelProps) => {
  const isSelecting = refreshData?.info?.is_selecting;
  const cr = refreshData?.cr;

  let panelClass = "vehiclePanel";
  const priority = cr?.priority ?? null;

  if (isSelecting === "1") {
    if (priority === 1) {
      panelClass = "vehiclePanel priority1";
    } else if (priority === 2) {
      panelClass = "vehiclePanel priority2";
    } else if (priority === 3) {
      panelClass = "vehiclePanel priority3";
    } else {
      panelClass = "vehiclePanel selectedByThis";
    }
  } else if (refreshData?.other_selecting) {
    panelClass = "vehiclePanel selectedByOther";
  } else if (refreshData?.drive?.monitor_f === "0") {
    panelClass = "vehiclePanel noMonitorF";
  } else {
    if (priority === 1) {
      panelClass = "vehiclePanel priority1";
    } else if (priority === 2) {
      panelClass = "vehiclePanel priority2";
    } else if (priority === 3) {
      panelClass = "vehiclePanel priority3";
    } else {
      panelClass = "vehiclePanel notSelected";
    }
  }

  return (
    <div className={panelClass}>
      <div className="headerArea">
        <VehicleSelect
          layoutId={layoutId}
          vehicle={vehicle}
          selectableVehicles={selectableVehicles}
          refreshData={refreshData}
          monitorConsoleId={monitorConsoleId}
          observeCC={observeCC}
          onevehicleCC={onevehicleCC}
          sendData={sendData}
          onReconnectJanus={onReconnectJanus}
          isAnyRemoteMode={isAnyRemoteMode}
        />
        <CrArea
          refreshData={refreshData}
          observeCC={observeCC}
          vehicle={vehicle}
          sendData={sendData}
        />
      </div>
      <div className="bottomArea">
        <div className="leftSide">
          <VideoSwitch
            refreshData={refreshData}
            observeCC={observeCC}
            vehicle={vehicle}
            sendData={sendData}
          />
          <AudioSwitch
            refreshData={refreshData}
            observeCC={observeCC}
            vehicle={vehicle}
            sendData={sendData}
            onModalOpen={onModalOpen}
          />
        </div>
        <div className="rightSide">
          <SoundSelect
            refreshData={refreshData}
            announcement={announcement}
            observeCC={observeCC}
            vehicle={vehicle}
            sendData={sendData}
            onModalOpen={onModalOpen}
          />
          {isEiheijiEnvironment() ? (
            <EiheijiRemoteControl
              refreshData={refreshData}
              vehicle={vehicle}
              isDepartureAnnounceActive={isDepartureAnnounceActive}
            />
          ) : (
            <RemoteAssist refreshData={refreshData} />
          )}
        </div>
      </div>
    </div>
  );
};

export default VehiclePanel;
